export const HOST = "http://45.124.86.67:3000";


// WEBPACK FOOTER //
// ./src/constants/API.js